import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import CombinedApp, { resolveCombinedVariant } from './CombinedApp'
import './styles.css'
import './styles-4180.css'
import './styles-4181.css'
import './styles-4182.css'
import './styles-4183.css'
import './styles-combined.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CombinedApp variant={resolveCombinedVariant(window.location.pathname)} />
  </StrictMode>,
)
